import { GroupedFilter } from 'module/types/filter-field/grouped-filter/filter';
import { ApiGroupFilter } from 'module/ui/components/molecules/field-filter/simple-search-filter/simple-search-filter';
import { HttpClient } from 'api/http-client';
import { SignalConfiguration } from 'api/signal/types';
// import { SignalType } from 'api/signal/types';
// import { SignalSource } from 'api/timeline/types';
// import { parseVTTToTranscript, sampleVttScript } from './parse-vtt';
import {
  Meeting,
  MeetingRecording,
  MeetingTranscript,
  PaginatedMeetingsResponse,
  CompanyWiseSourcesResponse,
  CompanyWiseSourceMeeting,
  SignalOccurrenceWithTimePeriod,
} from './types';

// const sampleMeetingRecording: MeetingRecording = {
//   videoUrl:
//     'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
// };

// Convert VTT parsed segments to MeetingTranscript format
// Group consecutive segments by the same speaker into one segment with multiple chunks
// const vttSegments = parseVTTToTranscript(sampleVttScript);
// const sampleMeetingTranscript: MeetingTranscript = {
//   segments: (() => {
//     const groupedSegments: MeetingTranscript['segments'] = [];
//     let currentSegment: (typeof groupedSegments)[0] | null = null;

//     for (const vttSegment of vttSegments) {
//       const speakerName =
//         vttSegment.speaker.fullName ||
//         vttSegment.speaker.firstName ||
//         'Unknown';

//       if (
//         currentSegment &&
//         currentSegment.speaker === speakerName &&
//         parseFloat(currentSegment.end) >= parseFloat(vttSegment.fromTime) - 5
//       ) {
//         // Same speaker, add as a new chunk to current segment
//         currentSegment.chunks.push({
//           start: vttSegment.fromTime,
//           end: vttSegment.toTime,
//           text: vttSegment.content,
//         });
//         // Update segment end time to the latest chunk end time
//         currentSegment.end = vttSegment.toTime;
//       } else {
//         // New speaker or gap, create a new segment
//         if (currentSegment) {
//           groupedSegments.push(currentSegment);
//         }
//         currentSegment = {
//           start: vttSegment.fromTime,
//           end: vttSegment.toTime,
//           speaker: speakerName,
//           chunks: [
//             {
//               start: vttSegment.fromTime,
//               end: vttSegment.toTime,
//               text: vttSegment.content,
//             },
//           ],
//         };
//       }
//     }

//     // Don't forget to add the last segment
//     if (currentSegment) {
//       groupedSegments.push(currentSegment);
//     }

//     return groupedSegments;
//   })(),
// };

// const sampleSignalOccurrencesWithTimePeriod: SignalOccurrenceWithTimePeriod[] =
//   [
//     {
//       signalOccurrence: {
//         signalOccurrenceId: 1,
//         signalConfigurationId: 101,
//         signalName: 'Product Demo Scheduled',
//         signalType: SignalType.Opportunity,
//         sourceId: 1,
//         sourceType: SignalSource.MEETING,
//         companyId: 1,
//         accountId: 1,
//         title: 'Product Demo Scheduled',
//         summary: 'Discussion about scheduling a product demo for the client',
//         metaData: {},
//         createdAt: new Date(),
//         fields: [],
//         reportedBy: [
//           {
//             emailId: 'vikram@rocketlane.com',
//             userId: 1,
//             firstName: 'Vikram',
//             lastName: 'Sathyanarayana',
//             userName: 'Vikram Sathyanarayana',
//             identityType: 'NATIVE',
//             role: {
//               roleName: 'Account Executive',
//             },
//           },
//         ],
//         citationMapping: {},
//       },
//       fromTime: '52.150',
//       toTime: '60.500',
//     },
//     {
//       signalOccurrence: {
//         signalOccurrenceId: 2,
//         signalConfigurationId: 102,
//         signalName: 'Follow-up Required',
//         signalType: SignalType.Operational,
//         sourceId: 1,
//         sourceType: SignalSource.MEETING,
//         companyId: 1,
//         accountId: 1,
//         title: 'Follow-up Required',
//         summary: 'Client requested additional information about pricing',
//         metaData: {},
//         createdAt: new Date(),
//         fields: [],
//         reportedBy: [
//           {
//             emailId: 'andy@rocketlane.com',
//             userId: 2,
//             firstName: 'Andy',
//             lastName: 'Lipski',
//             userName: 'Andy Lipski',
//             identityType: 'NATIVE',
//             role: {
//               roleName: 'Account Executive',
//             },
//           },
//         ],
//         citationMapping: {},
//       },
//       fromTime: '107.500',
//       toTime: '120.000',
//     },
//     {
//       signalOccurrence: {
//         signalOccurrenceId: 3,
//         signalConfigurationId: 103,
//         signalName: 'Budget Approval Needed',
//         signalType: SignalType.Risk,
//         sourceId: 1,
//         sourceType: SignalSource.MEETING,
//         companyId: 1,
//         accountId: 1,
//         title: 'Budget Approval Needed',
//         summary:
//           'Client mentioned they need to get budget approval before proceeding',
//         metaData: {},
//         createdAt: new Date(),
//         fields: [],
//         reportedBy: [
//           {
//             emailId: 'morgan@example.com',
//             userId: 3,
//             firstName: 'Morgan',
//             lastName: 'Steagall',
//             userName: 'Morgan Steagall',
//             identityType: 'EXTERNAL',
//             role: {
//               roleName: 'Client Representative',
//             },
//           },
//         ],
//         citationMapping: {},
//       },
//       fromTime: '125.640',
//       toTime: '145.130',
//     },
//     {
//       signalOccurrence: {
//         signalOccurrenceId: 4,
//         signalConfigurationId: 104,
//         signalName: 'Technical Integration Discussion',
//         signalType: SignalType.Operational,
//         sourceId: 1,
//         sourceType: SignalSource.MEETING,
//         companyId: 1,
//         accountId: 1,
//         title: 'Technical Integration Discussion',
//         summary:
//           'Discussion about technical requirements and integration possibilities',
//         metaData: {},
//         createdAt: new Date(),
//         fields: [],
//         reportedBy: [
//           {
//             emailId: 'vikram@rocketlane.com',
//             userId: 1,
//             firstName: 'Vikram',
//             lastName: 'Sathyanarayana',
//             userName: 'Vikram Sathyanarayana',
//             identityType: 'NATIVE',
//             role: {
//               roleName: 'Account Executive',
//             },
//           },
//         ],
//         citationMapping: {},
//       },
//       fromTime: '150.600',
//       toTime: '180.010',
//     },
//     {
//       signalOccurrence: {
//         signalOccurrenceId: 5,
//         signalConfigurationId: 105,
//         signalName: 'Next Steps Agreed',
//         signalType: SignalType.Opportunity,
//         sourceId: 1,
//         sourceType: SignalSource.MEETING,
//         companyId: 1,
//         accountId: 1,
//         title: 'Next Steps Agreed',
//         summary: 'Team agreed on next steps and timeline for implementation',
//         metaData: {},
//         createdAt: new Date(),
//         fields: [],
//         reportedBy: [
//           {
//             emailId: 'andy@rocketlane.com',
//             userId: 2,
//             firstName: 'Andy',
//             lastName: 'Lipski',
//             userName: 'Andy Lipski',
//             identityType: 'NATIVE',
//             role: {
//               roleName: 'Account Executive',
//             },
//           },
//         ],
//         citationMapping: {},
//       },
//       fromTime: '182.840',
//       toTime: '200.000',
//     },
//   ];

class MeetingAPIClient extends HttpClient {
  public async getAllMeetings(): Promise<Meeting[]> {
    return this.get<Meeting[]>('/meetings');
  }

  public async getAllMeetingsWithFilters(
    filter: GroupedFilter | undefined,
    pagination?: {
      offset?: number;
      limit?: number;
    },
  ): Promise<PaginatedMeetingsResponse> {
    var filterQueryString;

    if (filter) {
      filterQueryString = ApiGroupFilter.toQueryStringFormatForGroups(
        filter.groupCriteria,
      );
    }

    let url = '/meeting/search?';

    if (filter && filterQueryString) {
      url += `${filterQueryString}`;
      url += `&match=${filter.type}&`;
    }

    if (pagination?.offset !== undefined) {
      url += `offset=${pagination.offset}`;
    }
    if (pagination?.limit) {
      url += `&limit=${pagination.limit}`;
    }

    return this.get<PaginatedMeetingsResponse>(url);
  }

  public async getSignalOccurrencesForMeeting(
    meetingId: number,
    signalConfiguration: SignalConfiguration,
  ): Promise<any[]> {
    return this.post<any[], SignalConfiguration>(
      `/signals/configurations/preview?meetingId=${meetingId}`,
      signalConfiguration,
    );
  }

  public async searchMeetingsByCompanyId(
    companyId: number,
    options?: {
      offset?: number;
      limit?: number;
      searchTerm?: string;
    },
  ): Promise<PaginatedMeetingsResponse> {
    const { offset = 0, limit = 25, searchTerm } = options || {};
    let url = `/meeting/search?meeting*companyId.oneOf=${companyId}&match=all&offset=${offset}&limit=${limit}`;

    if (searchTerm) {
      url += `&meeting*title.contains=${encodeURIComponent(searchTerm)}`;
    }

    return this.get<PaginatedMeetingsResponse>(url);
  }

  public async getCompanyWiseSources<T = CompanyWiseSourceMeeting>(params: {
    sourceType: 'MEETING' | 'EMAIL';
    limit: number;
    offset: number;
    companyId: number;
    templateIds?: number[];
    isEnabled?: boolean;
    companyPageDocumentId?: number;
    searchTerm?: string;
  }): Promise<CompanyWiseSourcesResponse<T>> {
    const {
      sourceType,
      limit,
      offset,
      companyId,
      templateIds,
      isEnabled,
      companyPageDocumentId,
      searchTerm,
    } = params;

    let url = `/page-sources/company-wise-sources?sourceType=${sourceType}&limit=${limit}&offset=${offset}&companyId=${companyId}`;

    if (templateIds && templateIds.length > 0) {
      url += `&templateIds=${templateIds.join(',')}`;
    }

    if (isEnabled !== undefined) {
      url += `&isEnabled=${isEnabled}`;
    }

    if (companyPageDocumentId !== undefined) {
      url += `&companyPageDocumentId=${companyPageDocumentId}`;
    }

    if (searchTerm) {
      url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
    }

    return this.get<CompanyWiseSourcesResponse<T>>(url);
  }

  public async getCompanyV2Sources<T = CompanyWiseSourceMeeting>(params: {
    documentId: number;
    companyId: number;
    sourceType: 'MEETING' | 'EMAIL';
    limit: number;
    offset: number;
    fetchUsed?: boolean;
    isEnabled?: boolean;
  }): Promise<CompanyWiseSourcesResponse<T>> {
    const {
      documentId,
      companyId,
      sourceType,
      limit,
      offset,
      fetchUsed = true,
      isEnabled = true,
    } = params;

    let url = `/page-sources/company-v2-sources?documentId=${documentId}&companyId=${companyId}&sourceType=${sourceType}&limit=${limit}&offset=${offset}&fetchUsed=${fetchUsed}&isEnabled=${isEnabled}`;

    return this.get<CompanyWiseSourcesResponse<T>>(url);
  }

  public async getMeetingRecording(
    meetingId: number,
  ): Promise<MeetingRecording> {
    return this.get<MeetingRecording>(`/meeting/${meetingId}/recording`);
  }
  public async getMeetingTranscript(
    meetingId: number,
  ): Promise<MeetingTranscript> {
    return this.get<MeetingTranscript>(
      `/meeting/${meetingId}/transcript-combined`,
    );
  }
  public async getSignalOccurrencesForMeetingWithTimePeriod(
    meetingId: number,
  ): Promise<SignalOccurrenceWithTimePeriod[]> {
    return this.get<SignalOccurrenceWithTimePeriod[]>(
      `/meeting/${meetingId}/signal-occurrences-with-time-period`,
    ).catch(() => []);
  }
}
export const MeetingAPI = new MeetingAPIClient();
